// Slack alerts are off until a new webhook is implemented
// import AlertSlackOfError from "../../monitoring/AlertSlackOfError";
import { postUploadFunction } from "../../monitoring/postUploadFunction";
import { delay } from "./delay";

const clientFolder = "mgp-caliper";
const defaultScreenshot = `https://tastetest3d.sfo3.digitaloceanspaces.com/${clientFolder}/product-screenshots/default.jpg`;

export async function uploadImageToDigitalOcean(imageBase64, path) {
  try {
    const data = await postUploadFunction({ action: "spaces", imageBase64, path });
    if (!data || !data.location) throw new Error("Spaces upload failed");
    console.log(`uploadResult.Location ${data.location}`);
    return data.location;
  } catch (error) {
    // Slack alerts are off until a new webhook is implemented
    // AlertSlackOfError(`uploadImageToDigitalOcean: ${path}`, error, null);
    console.log(error);
    return defaultScreenshot;
  }
}

export async function hostCustomLogo(imageBase64) {
  let hostedUrl = await uploadImageToDigitalOcean(imageBase64, "customImageUpload");
  if (typeof hostedUrl === "string" && hostedUrl.slice(-11) === "default.jpg") {
    await delay(2000);
    hostedUrl = await uploadImageToDigitalOcean(imageBase64, "customImageUpload");
  }
  if (!hostedUrl || hostedUrl.slice(-11) === "default.jpg") {
    throw new Error("Custom logo upload failed.");
  }
  return hostedUrl;
}
